const installedDocuments = new WeakMap();

export function exactSearchQuery(value) {
  const query = value.trim();
  if (!query) return '';

  const hasAdvancedSyntax =
    /["()*\\]/u.test(query) ||
    /(?:^|\s)(?:AND|OR|NOT)(?=\s|$)/u.test(query) ||
    /(?:^|\s)-\S/u.test(query) ||
    /(?:^|\s)[\p{L}_][\p{L}\p{N}_.]*:/u.test(query) ||
    /(?:^|\s)'[^']*'(?=\s|$)/u.test(query);
  if (hasAdvancedSyntax) return value;

  const terms = query.split(/\s+/u);
  const hasIdentifier = terms.some((term) =>
    /^[\p{L}\p{N}._/+\-]+$/u.test(term) && (
      (/[\p{L}]/u.test(term) && /\p{N}/u.test(term)) ||
      /^\p{N}{6,}$/u.test(term) ||
      (/[A-Z]/u.test(term) && /^[A-Z\d]+(?:[-_./+][A-Z\d]+)+$/u.test(term)) ||
      (terms.length === 1 && /[\p{L}\p{N}][-_./+][\p{L}\p{N}]/u.test(term))
    )
  );
  if (hasIdentifier) return value;

  return terms.map((term) => `"${term}"`).join(' ');
}

function prepareSearch(event) {
  if (event.defaultPrevented) return;

  const form = event.target;
  if (form?.tagName !== 'FORM' || !form.hasAttribute('data-statues-strict-search')) return;
  if (form.method.toLowerCase() !== 'get') return;

  const input = form.elements.namedItem('q');
  if (input?.tagName !== 'INPUT' || input.disabled) return;

  input.value = exactSearchQuery(input.value);
}

export function installStatuesSearch(documentRoot) {
  const installed = installedDocuments.get(documentRoot);
  if (installed) return installed;

  const controller = new documentRoot.defaultView.AbortController();
  documentRoot.addEventListener('submit', prepareSearch, { capture: true, signal: controller.signal });

  const uninstall = () => {
    controller.abort();
    installedDocuments.delete(documentRoot);
  };
  installedDocuments.set(documentRoot, uninstall);
  return uninstall;
}

if (typeof document !== 'undefined') installStatuesSearch(document);
